import { useMemo } from 'react';

import pagerduty from 'src/lib/api/pagerduty-ui/pagerduty';
import { usePromise } from 'src/lib/hooks';

export const useCurrentUser = () => {
  const { data, loading, error } = usePromise(() => pagerduty.getMe(), []);

  return useMemo(() => ({
    user: data,
    loading,
    error,
  }), [data, loading, error]);
};
